"use client";

import Link, {LinkProps} from "next/link";
import {useCampusContext} from "../../../../_components/contexts/CampusCookieContext";
import {FCWithHTMLAttributes} from "../../../../types/reactTypes";
import {useSearchParams} from "next/navigation";

interface CampusCookieSetterLinkProps extends LinkProps {
	cookieValue?: string;
	shouldForwardQueryParams?: boolean;
}

const CampusCookieSetterLink: FCWithHTMLAttributes<
	CampusCookieSetterLinkProps
> = ({cookieValue, shouldForwardQueryParams = false, href, ...props}) => {
	const {setCampus} = useCampusContext();
	const onClick = () => {
		if (cookieValue) {
			setCampus(cookieValue);
		}
	};

	const queryParams = useSearchParams();
	const url = shouldForwardQueryParams
		? `${href}?${queryParams.toString()}`
		: href;
	return (
		<Link href={url} {...props} className="text-hyperlink" onClick={onClick} />
	);
};

export default CampusCookieSetterLink;
